import { css } from '@emotion/react';
import { theme } from '../../../theme';

const { primary } = theme.palette;

const menuIconWrapper = css`
  width: 22px;
  min-width: 22px;
  aspect-ratio: 1/1;
  position: relative;
  margin: 17px 0;

  & div {
    position: absolute;
    top: calc(50% - 1px);
    width: 22px;
    height: 2px;
    background: ${primary.main};
    transition: all 0.25s ease;
  }

  & div:nth-of-type(1) {
    top: 0;
  }

  & div:nth-of-type(3) {
    top: unset;
    bottom: 0;
  }
`;

const drawerWrapper = css`
  padding: 5px 25px 50px;
`;

export { menuIconWrapper, drawerWrapper };
